import * as React from "react";

import { useTheme } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import DashboardLayout from "../../../../Layouts/Dashboard/dashboard";

import { Outlet, useLocation, useNavigate, useParams } from "react-router";
import { assetService, cacheService, rightService } from "../../../../Core/Api/services";
import { GetMetadataByTagName } from "../../../../Core/Utils/asset-object-utils";
import GlobalConst from "../../../../Core/Utils/Constants/globals";

// Redux
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import ContractBanner from "../../../../Components/Banners/ContractBanner";
import SelectModeSubbarOpener from "../../../../Components/Banners/SelectModeBanner/opener";
import WishlistSelectModeSubbar from "../../../../Components/Banners/WishlistSelectModeBanner";
import { AclTypes } from "../../../../Core/Api/Types/acl-types";
import { DbAssetObjectInfos } from "../../../../Core/Api/Types/db-asset-object-infos";
import { DbMetadataFieldInfos } from "../../../../Core/Api/Types/db-metadata-field-infos";
import { ObjectLayer } from "../../../../Core/Api/Types/object-layer";
import { RightType } from "../../../../Core/Api/Types/right-type";
import {
  GetObject,
  IsObjectLoading,
  SetActiveRight,
  SetFetchedObject,
  SetLoading,
} from "../../../../Redux/Reducers/redux-slice-asset";
import { UserHasAcl } from "../../../../Utils/helpers";
import useCustomSnackbar from "../../../../Utils/Hooks/useCustomSnackbar";
import { ContractAndRightType } from "../../../../Core/Api/Right/right-api-service";
import TitleHeading from "./title-single-heading";
import { useTranslation } from "react-i18next";
import DriveSelectModeBanner from "../../../../Components/Banners/DriveSelectModeBanner";
import { SetExpandedItems, SetTreeObj, TreeContext } from "../../../../Redux/Reducers/redux-slice-tree";

function InventoryTitle() {
  const { t } = useTranslation();
  const params = useParams();
  const titleId: number = parseInt(params.id!) || 0;
  const title = useSelector(GetObject);
  const isLoading = useSelector(IsObjectLoading);
  const customerExtIdName = cacheService.GetCustomerExternalIdLabel();
  const metadata: DbMetadataFieldInfos[] = cacheService.GetMetadata();
  const [posterViewerVisible, setPosterViewerVisible] = useState(false);
  const location = useLocation();

  const theme = useTheme();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const enqueueSnackbar = useCustomSnackbar();

  const [selectedItems, setSelectedItems] = useState<DbAssetObjectInfos[]>([]);
  const [selectedContracts, setSelectedContracts] = useState<ContractAndRightType[]>([]);
  const [canSelectedItemsBeShared, setCanSelectedItemsBeShared] = useState(true);

  const handleBrowsingSubbarCloseClick = () => {
    setSelectedItems([]);
    setSelectedContracts([]);
  };

  const productionDate = useMemo(
    () => GetMetadataByTagName(title!, "productionDate", metadata)?.value,
    [title, metadata]
  );

  useEffect(() => {
    dispatch(SetLoading(true));

    if (titleId === 0) return;

    assetService
      .GetGraph(titleId, true, true, false)
      .then(function (response) {
        if (!response || !response.graph) {
          enqueueSnackbar(t("alert:error.unableToFetchTitle", { id: titleId }), "error");
          return;
        }

        console.log("title:GetGraph(" + titleId + ") ok");

        dispatch(SetFetchedObject(response));
        dispatch(SetTreeObj({ context: TreeContext.TitlePanel, obj: response.graph }));
        dispatch(SetExpandedItems({ context: TreeContext.TitlePanel, expandedIds: [titleId], replace: true }));
        dispatch(SetTreeObj({ context: TreeContext.AssetHierarchy, obj: response.graph }));
        dispatch(SetExpandedItems({ context: TreeContext.AssetHierarchy, expandedIds: [titleId], replace: true }));
        dispatch(SetLoading(false));
      })
      .catch(function () {
        navigate(GlobalConst.DEFAULT_REDIRECT_PATH);
      });

    // Load active rights
    if (UserHasAcl(AclTypes.aclRightsView)) {
      rightService.GetRightContractByTitleIdBasic(titleId, RightType.Acquisition).then((response) => {
        let now = moment();
        let active =
          response.right !== null &&
          response.right.deals !== null &&
          response.right.deals.length > 0 &&
          response!.right!.deals!.filter(
            (x) => x.rights !== null && x.rights.filter((r) => moment(r.endDate!) > now).length > 0
          ).length > 0;

        console.log("title:RightActive(" + active + ")");

        dispatch(SetActiveRight({ show: true, active: active }));
      });
    } else dispatch(SetActiveRight({ show: false, active: false }));
  }, [titleId]);

  return (
    <>
      <DashboardLayout
        sxContent={{ px: location.pathname.includes("drive") ? 0 : 2 }}
        transparentTopbar
        stickiesVisibleAt={160}
        Banner={
          location.pathname.includes("drive") ? (
            <DriveSelectModeBanner
              items={selectedItems}
              handleCloseClick={handleBrowsingSubbarCloseClick}
              layer={ObjectLayer.Asset}
              itemsCanBeShared={canSelectedItemsBeShared}
            />
          ) : selectedContracts.length === 0 ? (
            <WishlistSelectModeSubbar
              items={selectedItems}
              handleCloseClick={handleBrowsingSubbarCloseClick}
              layer={ObjectLayer.Asset}
              itemsCanBeShared={canSelectedItemsBeShared}
            />
          ) : (
            <ContractBanner contracts={selectedContracts} handleCloseClick={handleBrowsingSubbarCloseClick} />
          )
        }
        Heading={<TitleHeading titleId={titleId} />}
      >
        <SelectModeSubbarOpener
          selectedObjects={selectedContracts.length === 0 ? selectedItems : selectedContracts.map((x) => x.id)}
        />
        <Outlet
          context={{
            selectedItems: selectedItems,
            setSelectedItems: setSelectedItems,
            selectedContracts: selectedContracts,
            setSelectedContracts: setSelectedContracts,
            setCanSelectedItemsBeShared: setCanSelectedItemsBeShared,
          }}
        />
      </DashboardLayout>
    </>
  );
}

export default InventoryTitle;
